import { ICustomerDashTheme } from '../customTypings/tenantTheme';

import { BaseTenantTheme } from './tenantTheme.base';

export const TenantTheme: ICustomerDashTheme = BaseTenantTheme;
